module.exports = require("semver");